module.exports = __webpack_public_path__ + "img/first-section-1.43c1c3ec.jpg";